import React from 'react';
import { UserOutlined, InfoCircleOutlined } from '@ant-design/icons';

const ClaimPersonalInfo = ({ data }) => {
  const safeVal = (val) => (!val || val === 'Pendiente') ? '--' : val;

  return (
    <div>
      <div className="claim-card">
        <div className="claim-card-title">
          <UserOutlined className="claim-card-title-icon" /> Información Personal
        </div>
        <div className="claim-info-list">
          <div className="claim-info-row">
            <span className="claim-info-row-label">Nombre(s)</span>
            <span className="claim-info-row-value">{safeVal(data.firstName)}</span>
          </div>
          <div className="claim-info-row">
            <span className="claim-info-row-label">Apellidos</span>
            <span className="claim-info-row-value">{safeVal(data.lastName)}</span>
          </div>
          <div className="claim-info-row">
            <span className="claim-info-row-label">Teléfono / Celular</span>
            <span className="claim-info-row-value">{safeVal(data.phone)}</span>
          </div>
          <div className="claim-info-row">
            <span className="claim-info-row-label">Correo electrónico</span>
            <span className="claim-info-row-value">{safeVal(data.email)}</span>
          </div>
        </div>
      </div>

      <div className="claim-card">
        <div className="claim-card-title">
          <span className="claim-card-title-icon" style={{ fontSize: 18 }}>🏛</span> Información Bancaria
        </div>
        <div className="claim-info-list">
          <div className="claim-info-row">
            <span className="claim-info-row-label">Banco</span>
            <span className="claim-info-row-value">{safeVal(data.bankName)}</span>
          </div>
          <div className="claim-info-row">
            <span className="claim-info-row-label">Cuenta Bancaria (CLABE)</span>
            <span className="claim-info-row-value">{safeVal(data.clabe)}</span>
          </div>
          <div className="claim-info-row">
            <span className="claim-info-row-label">Nombre del Propietario</span>
            <span className="claim-info-row-value">{safeVal(data.accountHolder)}</span>
          </div>
        </div>
        
        <div className="claim-alert warning">
          <InfoCircleOutlined />
          Verifica cuidadosamente que la información bancaria corresponda al titular y sea correcta.
        </div>
      </div>
    </div>
  );
};

export default ClaimPersonalInfo;
